import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Grid({ color = 'icon.gray', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 21' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.35756 8.56527H4.98798C4.03584 8.56527 3.26465
           7.79408 3.26465 6.84194V4.47236C3.26465 3.52022
            4.03584 2.74902 4.98798 2.74902H7.35756C8.30971
             2.74902 9.0809 3.52022 9.0809 4.47236V6.84194C9.0809
              7.79408 8.30971 8.56527 7.35756 8.56527Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.83'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0514 8.56527H14.6818C13.7297 8.56527 12.9585
           7.79408 12.9585 6.84194V4.47236C12.9585 3.52022 13.7297
            2.74902 14.6818 2.74902H17.0514C18.0036 2.74902 18.7747
             3.52022 18.7747 4.47236V6.84194C18.7747 7.79408 18.0036
              8.56527 17.0514 8.56527Z'
        stroke={color}
        strokeWidth='1.83'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.35756 18.2591H4.98798C4.03584 18.2591 3.26465
           17.4879 3.26465 16.5358V14.1662C3.26465 13.2141 4.03584
            12.4429 4.98798 12.4429H7.35756C8.30971 12.4429 9.0809
             13.2141 9.0809 14.1662V16.5358C9.0809 17.4879 8.30971
              18.2591 7.35756 18.2591Z'
        stroke={color}
        strokeWidth='1.83'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0514 18.2591H14.6818C13.7297 18.2591 12.9585
           17.4879 12.9585 16.5358V14.1662C12.9585 13.2141 13.7297
            12.4429 14.6818 12.4429H17.0514C18.0036 12.4429 18.7747
             13.2141 18.7747 14.1662V16.5358C18.7747 17.4879 18.0036
              18.2591 17.0514 18.2591Z'
        stroke={color}
        strokeWidth='1.83'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Grid.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Grid
